module.exports = __webpack_public_path__ + "img/Rust-3-mobile.8d609309.png";